<!-- =========================================================================================
    File Name: TheHeader.vue
    Description: Header component
   ========================================================================================== -->

<template>
  <div>
    <header>
     <router-link to="/dashboard" class="return_back"> {{pagetitle}} </router-link>
      <div class="header_right">
        <ul>
          <li class="mob_search"  :class="{active: isSearchActive}" @click="isSearchOpen=false; isSearchActive = !isSearchActive">
            <!--<img src="@/assets/images/search_mob.svg" alt="filters" />-->
          </li>
          <li class="padr10" style="display:none !important">
            <div class="view_switch" >
              <span
                class="gridview"
                v-on:click="isGrid = true; isList =false"
                :class="{ 'active': isGrid}"
              ></span>
              <span
                class="listview"
                v-on:click="isList = true; isGrid = false"
                :class="{ 'active': isList}"
              ></span>
            </div>
          </li>
          <li class="padr10 headersearch" :class="{searchopen: isSearchActive}">
            <input type="text" placeholder="Search user" v-model="serchTitle" @keyup="serch_title()" />
          </li>
          <li class="padr10">
            <button class="filters_btn" :class="{'active': isfilterOpen}" @click="isfilterOpen = !isfilterOpen" >
               Filters
            </button>
          </li>
          <li class="notification" :class="{active: isOpen}" @click="isOpen = !isOpen;isfilterOpen=false;">
            <v-icon>mdi-bell-outline</v-icon>
          </li>

        </ul>
      </div>
      <div class="filters_wrap" :class="{'filteropen': isfilterOpen}">
        <div class="filters_content form_wrap">
          
          <form>
            <v-row>
               <v-col cols="12" sm="4">
                
                <label class="form-label">Role</label>
                     <multiselect  
                    v-model="selected_userRoles" 
                    :options="userRoles" 
                    :close-on-select="false" 
                    :clear-on-select="false" 
                    :hide-selected="false" 
                    :preserve-search="true" 
                    placeholder="Select " 
                    label="name" 
                    track-by="name" 
                    :preselect-first="true"
                    id="role"
                    :multiple="true" >
                    <template slot="selection" slot-scope="{ values, isOpen }">
                      <span class="multiselect__selectcustom" 
                      v-if="values.length && !isOpen">{{ values.length }} Role(s) selected</span>
                      <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                    </template>
                    <span slot="noResult">No Roles Found</span>
                    </multiselect>
              </v-col>

              <!--<v-col cols="12" sm="4">
                <label class="form-label">Created On</label>
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="260px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dateRangeText"
                      placeholder="Select "
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker placeholder="Range" :max="nowDate"  v-model="dates" range @change="save"></v-date-picker>
                </v-menu>
              </v-col>-->

              <v-col cols="12" sm="4">
                <label class="form-label">Status</label>
                     <multiselect  
                    v-model="selected_statuss" 
                    :options="status_list" 
                    :close-on-select="false" 
                    :clear-on-select="false" 
                    :hide-selected="false" 
                    :preserve-search="true" 
                    placeholder="Select " 
                    label="name" 
                    track-by="name" 
                    :preselect-first="true"
                    id="status"
                    :multiple="true"
                    >
                    <template slot="selection" slot-scope="{ values, isOpen }">
                      <span class="multiselect__selectcustom" 
                      v-if="values.length && !isOpen">{{ values.length }} Status(es) selected</span>
                      <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                    </template>
                    <span slot="noResult">No Status Found</span>
                    </multiselect>
              </v-col>            
                   
            </v-row>
            <v-row>
              <div class="actions justify-content-between padl12"> 
                <span @click="isfilterOpen = !isfilterOpen;cancle_filter()" class="cancel_btn clear_filter" >Clear Filter</span>
                <div>
                  <span class="cancel_btn" @click="isfilterOpen = !isfilterOpen" >cancel</span>
                  <v-btn class="primary_button"  @click.stop="apply_filter();listdialog=false;isfilterOpen=false" >Apply</v-btn>
                </div>
              </div>
            </v-row>
          </form> 

        </div>
        <span class="modalclose" @click="isfilterOpen = !isfilterOpen"></span>
      </div>
    </header>
   
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect-inv'
import _ from 'lodash'
import moment from 'moment'


export default {
  name: 'the-header',

  data: () => ({
    nowDate: new Date().toISOString().slice(0, 10),
    userdata:null,
    pagetitle:null,
    awesome: true,
    windowWidth: 0,
    isOpen: false,
    isSearchActive:false,
    isfilterOpen:false,
    isSearchOpen:false,
    isGrid: true,
    isList: false,
    listdialog: false,
    items: [],
    value: [],
    dates: [],
    date: null,
    menu: false,
    selected: null,
    options: ['option1', 'option2', 'option3', 'option5', 'option52', 'option35', 'option56', 'option62', 'option73'],

    serchTitle:'',

    selected_statuss:[],
    status_list:[],

    startDate:new Date(),
    endDate:new Date(),
     
    userRoles:[],
    selected_userRoles:[]
    
      
  }),
  computed: {
    dateRangeText () {
      //return this.dates.join(" - ");
      if (this.dates.length > 1) {
        const m1 = moment(this.dates[0]).format('YYYY-MM-DD')
        const m2 = moment(this.dates[1]).format('YYYY-MM-DD')
        if (m2 < m1) {
          //this.dates = [m2 ,m1]
          const d = [m2, m1]
          //alert();
          return d.join(' - ')


        } else {
          return this.dates.join(' - ')
        }

      } else {
        return this.dates.join(' - ')
      }

    }
  },
  mounted () {
    this.userdata = this.$store.getters.getuser
    if (this.$route.meta.title) this.pagetitle = this.$route.meta.title

    const startDate = new Date()
    const endDate = new Date()
    startDate.setDate(startDate.getDate() - 60)
    this.dateRange = {startDate, endDate}

    this.$store.dispatch('getRoles').then((response) => {
      this.userRoles = response;
    })

    //getuser_status

    this.$store.dispatch('getuser_status').then((response) => {
      this.status_list = response;
    })

  },
  methods: {
    updateProfilecb () {
      this.$parent.$parent.updateprofilepopup  = true
    },
    changePasswordcb () {
      this.$parent.$parent.changepassword = true
    },


    serch_title () {
      this.$emit('serchTitle', {value:this.serchTitle})

    },


    apply_filter () {
   
      if (this.dates.length > 1) {
        const m1 = moment(this.dates[0]).format('YYYY-MM-DD')
        const m2 = moment(this.dates[1]).format('YYYY-MM-DD')
        if (m2 < m1) {
          this.dates = [m2, m1]
        }
      }

      const filterData = {'roleIds':[], 'statusIds':[], 'createdByIds':[], 'dateRange':this.dates}
   
      if (this.selected_userRoles.length > 0) {
        filterData['roleIds'] = []
        for (let i = 0; i < this.selected_userRoles.length; i++) {

          filterData['roleIds'].push(this.selected_userRoles[i]['_id'])

        }
     
      }

      if (this.selected_statuss.length > 0) {
        filterData['statusIds'] = []
        for (let i = 0; i < this.selected_statuss.length; i++) {

          filterData['statusIds'].push(this.selected_statuss[i]['_id'])

        }
     
      }

      this.$emit('applyFilter', filterData)
      this.listdialog = false
    

    },
    cancle_filter () {
    //cancle_filter
      this.serchTitle = ''
      this.selected_userRoles = []
      this.selected_statuss = []
      this.dates = []
      this.$emit('cancle_filter')

    },
    logout () {
      this.$store.dispatch('logout').then(() => {
        this.$router.push('/')
      })
    },
    save (date) {
      this.$refs.menu.save(date)
    }
  },
  components: { 
    Multiselect
  }
}
</script>
